import {EFileEncoding} from '../model/constants';

/**
 * Преобразует строку в формате Base64 в бинарный массив (ArrayBuffer).
 *
 * @param base64String Строка в формате Base64, которую необходимо декодировать.
 * @returns Объект типа ArrayBuffer, представляющий бинарные данные.
 * @throws Ошибка, если входная строка не является допустимой строкой Base64.
 */
export const base64ToDer = (base64String: string): Uint8Array => {
    try {
        const binaryString = atob(base64String);
        return Uint8Array.from(binaryString, char => char.charCodeAt(0));
    } catch (error) {
        throw new Error('Invalid Base64 string');
    }
};

/**
 * Генерирует данные для файла подписи на основе строки подписи и выбранной кодировки файла.
 *
 * @param signature Строка подписи, закодированная в формате Base64.
 * @param fileEncoding Кодировка файла, по умолчанию используется Base64.
 * Возможные значения:
 * - `FileEncoding.BASE64` — оставляет данные в формате Base64.
 * - `FileEncoding.DER` — преобразует данные в формат DER (binary).
 *
 * @returns Объект с данными файла подписи, содержащий:
 * - `file` — строку или бинарный массив в зависимости от выбранной кодировки.
 * - `type` — MIME-тип файла: 'text/plain' или 'application/octet-stream'.
 */
export const getFormattedSignatureData = (
    signature: string,
    fileEncoding: EFileEncoding = EFileEncoding.BASE64,
) => {
    const signatureFileData: { file: string | Uint8Array; type: string } = {
        file: signature,
        type: 'text/plain',
    };

    if (fileEncoding === EFileEncoding.DER) {
        signatureFileData.file = base64ToDer(signature);
        signatureFileData.type = 'application/octet-stream';
    }

    return signatureFileData;
};
